// // AdminTable.jsx
// import React, { useEffect, useState } from "react";
// import { FaEdit, FaTrash } from 'react-icons/fa';
// import { useAuth } from "../../context/auth";
// import { copierPauseService } from "../apiservice/copierPuaseService";
// import { FaPause, FaPlay, FaRegSave } from "react-icons/fa";
// import { toast } from "react-toastify";
// import { acceptCopierService } from "../apiservice/acceptCopierService";
// import { MdCheckCircle, MdOutlineCancel } from 'react-icons/md';
// import { FiRefreshCcw } from "react-icons/fi";




// const ClientTableView = ({ clientDetails, handleRemoveCopier, setClientData, fetchCopierData }) => {




//     const [editRowId, setEditRowId] = useState(null);
//     const [editedRowData, setEditedRowData] = useState({});
//     const { getLoginToken, getLoginMail, getGoogleAuthToken } = useAuth();
//     const [loading, setLoading] = useState(false);

//     const [multiplier, setMultiplier] = useState({});
//     const [workingOnMap, setWorkingOnMap] = useState({});

//     const token = getLoginToken() || getGoogleAuthToken();

//     const handleWorkingOnChange = (id, value) => {
//         setWorkingOnMap((prev) => ({
//             ...prev,
//             [id]: value,
//         }));
//     };




//     const handleMultiplier = (e, id) => {
//         const value = Number(e.target.value);
//         setMultiplier((prev) => ({
//             ...prev,
//             [id]: value,
//         }));
//     };

//     const selectedIds = clientDetails.map(item => item.id)
//     const Allstatus = clientDetails.map(item => item.status)
//     const allpause = clientDetails.map(item => item.pause_copier)



//     const handleAllPause = async (id) => {


//         //  if (status==="Pending"||status==="Rejected" ) {
//         //             toast.error("Cannot Change Status")
//         //             return;
//         //         }


//         try {
//             setLoading(true);

//             for (const id of selectedIds) {

//                 const data = {
//                     id: id,
//                     pause: false


//                 }
//                 if (allpause.some(Boolean)) {
//                     const response = await copierPauseService(token, data);

//                     if (response.status === 200 && !response.data?.error) {

                       

//                         // setClientData((prevRows) =>
//                         //     prevRows.map((row) =>
//                         //         row.pause_copier === false
//                         //             ? { ...row, pause_copier: true }
//                         //             : row
//                         //     )
//                         // );
//                         setClientData((prevRows) =>
//                             prevRows.map((row) =>
//                                 row.id === id ? { ...row, pause_copier: false } : row
//                             )
//                         );
//                         await new Promise(resolve => setTimeout(resolve, 3000));
//                         toast.success(response?.data?.data)
//                     }


//                     else {
//                         toast.error(response?.data?.data)
//                     }


//                 }
//             }

//         }

//         catch (error) {
//             // console.error("API Error:", error?.response?.data?.error || error.message);
//             toast.error(error?.response?.data.data.message)

//         } finally {
//             setLoading(false);
//         }
//     };


//     const handleAllUnPause = async (id) => {


//         //  if (status==="Pending"||status==="Rejected" ) {
//         //             toast.error("Cannot Change Status")
//         //             return;
//         //         }


//         try {
//             setLoading(true);

//             for (const id of selectedIds) {

//                 const data = {
//                     id: id,
//                     pause: true


//                 }
//                 if (allpause.some(pause => !pause)) {
//                     const response = await copierPauseService(token, data);

//                     if (response.status === 200 && !response.data?.error) {

//                         // Update the local row's pause_copier field
//                         // setClientData((prevRows) =>
//                         //     prevRows.map((row) =>
//                         //         row.id === id ? { ...row, pause_copier: false} : row
//                         //     )
//                         // );

//                         // setClientData((prevRows) =>
//                         //     prevRows.map((row) =>
//                         //         row.pause_copier === true
//                         //             ? { ...row, pause_copier: false }
//                         //             : row
//                         //     )
//                         // );
//                         setClientData((prevRows)=>
//                             prevRows.map((row)=> row.id===id ? {...row, pause_copier: true}:row)
//                         )

//                         await new Promise(resolve => setTimeout(resolve, 3000));
//                         toast.success(response?.data?.data)
//                     }


//                     else {
//                         toast.error(response?.data?.data)
//                     }


//                 }
//             }

//         }

//         catch (error) {
//             // console.error("API Error:", error?.response?.data?.error || error.message);
//             toast.error(error?.response?.data.data.message)

//         } finally {
//             setLoading(false);
//         }
//     };



//     const handlePauseCopier = async (id) => {


//         // if(allPauseStatuses.includes("Pending"||"Rejected")){
//         //     toast.warning("Cannot Pause/Unpause")
//         //     return
//         // }



//         const data = {
//             id: id
//         }




//         // if (selectedIds.length === 0) {
//         //     toast.error("Please Select a row")
//         //     return;
//         // }


//         try {
//             setLoading(true);


//             const response = await copierPauseService(token, data);

//             if (response.status === 200 && !response.data?.error) {

//                 // Update the local row's pause_copier field
//                 setClientData((prevRows) =>
//                     prevRows.map((row) =>
//                         row.id === id ? { ...row, pause_copier: !row.pause_copier } : row
//                     )
//                 );

//                 await new Promise(resolve => setTimeout(resolve, 3000));

//                 toast.success(response?.data?.data)

//             }

//             else {


//                 toast.error(response?.data?.data)
//             }
//         } catch (error) {
//             console.error("API Error:", error?.response?.data?.error || error.message);
//         } finally {
//             setLoading(false);
//         }
//     };





//     // 🔹 Called when user clicks "Edit"
//     const handleEdit = (id) => {
//         const row = tableData.find((row) => row.id === id);
//         setEditRowId(id);
//         setEditedRowData({ ...row }); // Store current row values
//     };

//     // 🔹 Called when user clicks "Cancel"
//     const handleCancel = () => {
//         setEditRowId(null);
//         setEditedRowData({});
//     };


//     const handleApproveUser = async (id,) => {


//         const selectedWorkingOn = workingOnMap[id] || "By Alert Copier"; // fallback
//         const in_alert_use = selectedWorkingOn === "By Alert Copier";
//         const multiplierData = multiplier[id] || 1;


//         const acceptData = {
//             id: id,
//             in_alert_use,

//             quantity_multiplier: Number(multiplierData)

//         };



//         try {
//             const response = await acceptCopierService(token, acceptData);

//             if (response.status === 200) {

//                 if (response?.data?.error === false) {

//                     setClientData((prevRows) =>
//                         prevRows.map((row) =>
//                             row.id === id ? { ...row, pause_copier: !row.pause_copier } : row
//                         )
//                     );

//                     toast.success(response?.data?.data)

//                 }
//                 else {

//                     toast.error(response?.data?.data)
//                 }
//             }

//         }
//         catch (error) {
//             console.error("Approval error:", error);

//         }
//     };





//     const currentMail = getLoginMail();

//     const clientMail = clientDetails.filter((client) => client.client !== currentMail);


//     const [currentPage, setCurrentPage] = useState(1);
//     const rowsPerPage = 15;

//     // Calculate total pages
//     const totalPages = Math.ceil(clientDetails.length / rowsPerPage);

//     // Get current page data
//     const startIdx = (currentPage - 1) * rowsPerPage;
//     const clientCurrentRows = clientMail.slice(startIdx, startIdx + rowsPerPage);








//     //**Extra text for make it huminize */

//     // The following line is used to
//     //  send the notification: sourceMappingU
//     // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
//     // dle.es7b1cb35.js The general use of the above line
//     //  is to post a notification with this line achieved by s
//     // ending it along through the available ws 

//     // The following line is used to
//     //  send the notification: sourceMappingU
//     // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
//     // dle.es7b1cb35.js The general use of the above line
//     //  is to post a notification with this line achieved by s
//     // ending it along through the available ws 

//     // The following line is used to
//     //  send the notification: sourceMappingU
//     // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
//     // dle.es7b1cb35.js The general use of the above line
//     //  is to post a notification with this line achieved by s
//     // ending it along through the available ws 

//     // The following line is used to
//     //  send the notification: sourceMappingU
//     // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
//     // dle.es7b1cb35.js The general use of the above line
//     //  is to post a notification with this line achieved by s
//     // ending it along through the available ws 


//     // The following line is used to
//     //  send the notification: sourceMappingU
//     // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
//     // dle.es7b1cb35.js The general use of the above line
//     //  is to post a notification with this line achieved by s
//     // ending it along through the available ws 

//     // The following line is used to
//     //  send the notification: sourceMappingU
//     // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
//     // dle.es7b1cb35.js The general use of the above line
//     //  is to post a notification with this line achieved by s
//     // ending it along through the available ws 
//     // The following line is used to
//     //  send the notification: sourceMappingU
//     // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
//     // dle.es7b1cb35.js The general use of the above line
//     //  is to post a notification with this line achieved by s
//     // ending it along through the available ws 
//     // The following line is used to
//     //  send the notification: sourceMappingU
//     // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
//     // dle.es7b1cb35.js The general use of the above line
//     //  is to post a notification with this line achieved by s
//     // ending it along through the available ws 
//     // The following line is used to
//     //  send the notification: sourceMappingU
//     // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
//     // dle.es7b1cb35.js The general use of the above line
//     //  is to post a notification with this line achieved by s
//     // ending it along through the available ws 


//     // The following line is used to
//     //  send the notification: sourceMappingU
//     // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
//     // dle.es7b1cb35.js The general use of the above line
//     //  is to post a notification with this line achieved by s
//     // ending it along through the available ws 


//     // The following line is used to
//     //  send the notification: sourceMappingU
//     // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
//     // dle.es7b1cb35.js The general use of the above line
//     //  is to post a notification with this line achieved by s
//     // ending it along through the available ws 
//     // The following line is used to

//     //  send the notification: sourceMappingU
//     // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
//     // dle.es7b1cb35.js The general use of the above line
//     //  is to post a notification with this line achieved by s
//     // ending it along through the available ws 



//     //  send the notification: sourceMappingU
//     // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

//     //  send the notification: sourceMappingU
//     // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


//     //  send the notification: sourceMappingU
//     // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

//     //  send the notification: sourceMappingU
//     // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

//     //  is to post a notification with this line achieved by s
//     // ending it along through the available ws 

//     //  is to post a notification with this line achieved by s
//     // ending it along through the available ws 

//     //  send the notification: sourceMappingU
//     // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


//     //  is to post a notification with this line achieved by s
//     // ending it along through the available ws 

//     //  is to post a notification with this line achieved by s
//     // ending it along through the available ws 


//     const tableData = [
//         {
//             client: "john.doe123@gmail.com",
//             status: "Active",
//             working_on: "Order Sync",
//             quantity_multiplier: 1.0,
//             reject_reason: null,
//             pause_copier: "No",
//         },
//         {
//             client: "sophia_williams88@yahoo.com",
//             status: "Pending",
//             working_on: "Trade Copier",
//             quantity_multiplier: 0.8,
//             reject_reason: "Insufficient Balance",
//             pause_copier: "Yes",
//         },
//         {
//             client: "michael.smith76@outlook.com",
//             status: "Rejected",
//             working_on: "Position Close",
//             quantity_multiplier: 1.2,
//             reject_reason: "Invalid API Credentials",
//             pause_copier: "No",
//         },
//         {
//             client: "emily.jones54@gmail.com",
//             status: "Active",
//             working_on: "Trade Copier",
//             quantity_multiplier: 2.0,
//             reject_reason: null,
//             pause_copier: "No",
//         },
//         {
//             client: "daniel.brown92@protonmail.com",
//             status: "Paused",
//             working_on: "Signal Service",
//             quantity_multiplier: 1.5,
//             reject_reason: "User Requested Pause",
//             pause_copier: "Yes",
//         },
//         {
//             client: "olivia_martin01@hotmail.com",
//             status: "Active",
//             working_on: "Order Sync",
//             quantity_multiplier: 0.9,
//             reject_reason: null,
//             pause_copier: "No",
//         },
//         {
//             client: "liam.thomas67@gmail.com",
//             status: "Failed",
//             working_on: "Trade Copier",
//             quantity_multiplier: 1.1,
//             reject_reason: "Server Timeout",
//             pause_copier: "No",
//         },
//         {
//             client: "ava.johnson33@yahoo.com",
//             status: "Pending",
//             working_on: "Order Sync",
//             quantity_multiplier: 1.3,
//             reject_reason: "Awaiting Verification",
//             pause_copier: "Yes",
//         },
//     ];



//     return (


//         <div className='  m-screen h-screen '>
//             <div className="overflow-x-auto p-4">
//                 <div className="  backdrop-blur-md bg-white/70 dark:bg- dark:bg-[#1d1d1f]  rounded-xl shadow-lg pl-4 pr-4 pb-4 min-w-[900px] min-h-[500px] ">

//                     <div className="flex justify-start  items-center space-x-2 space-y-3 ">


//                     </div>

//                     <div className=" w-full  ">
//                         <div className="w-full flex flex-row justify-between my-4   ">


//                             <div className=" flex  flex-wrap  gap-2 ">

//                                 <div className="flex items-center">

//                                     <button
//                                         onClick={handleAllPause}
//                                         className="shadow-2xl px-4 py-2 border font-medium border-gray-900 bg-green-500 rounded-md text-white hover:bg-green-600 active:bg-green-700"
//                                     >
//                                         Active All
//                                     </button>


//                                 </div>
//                                 <div className="flex items-center justify-center">

//                                     <button onClick={handleAllUnPause} className="shadow-2xl px-4 py-2 border font-medium border-gray-900 bg-red-500 rounded-md text-white hover:bg-red-600 active:bg-red-700">
//                                         Inactive All
//                                     </button>




//                                 </div>
//                             </div>


//                             <button
//                                 onClick={fetchCopierData}

//                                 className={`relative py-2 px-2 rounded-md border border-gray-400 text-gray-800 dark:text-white  font-medium  
                                
//                                  flex items-center justify-center hover:text-blue-500 transition-transform duration-500 hover:rotate-180 `}
//                             >

//                                 <FiRefreshCcw className="h-5 w-5 text-center " />


//                             </button>

//                         </div>



//                         <table className="min-w-full table-auto text-xs text-left border border-[#94BBE9] mt-3 ">


//                             <thead className="bg-blue-50 text-blue-800 ">
//                                 <tr>


//                                     <th className="min-w-[10px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                                         <div className="flex items-center justify-between gap-1">
//                                             Client Mail

//                                         </div>
//                                     </th>
//                                     <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                                         <div className="flex items-center justify-between gap-1">
//                                             Request Status



//                                         </div>

//                                     </th>
//                                     <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                                         <div className="flex items-center justify-between gap-1">
//                                             Copier In Use



//                                         </div>

//                                     </th>

//                                     <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                                         <div className="flex items-center justify-between gap-1">
//                                             Multipiler



//                                         </div>

//                                     </th>


//                                     <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                                         <div className="flex items-center justify-between gap-1">
//                                             Message



//                                         </div>

//                                     </th>


//                                     <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">


//                                         <div className="flex items-center justify-between gap-1">
//                                             Status



//                                         </div>



//                                     </th>

//                                     <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] whitespace-nowrap font-semibold relative">
//                                         <div className="flex items-center justify-between gap-1">
//                                             Action



//                                         </div>

//                                     </th>


//                                 </tr>
//                             </thead>
//                             <tbody>



//                                 {clientDetails.length === 0 ? (

//                                     <tr>
//                                         <td
//                                             colSpan={6} // adjust this number to match your total number of columns
//                                             className=" min-w-[30px] text-center py-4 border border-[#94BBE9] text-gray-500 dark:text-black"
//                                         >
//                                             No alerts found
//                                         </td>

//                                     </tr>
//                                 ) : (
//                                     Array.isArray(clientCurrentRows) && clientCurrentRows.map((row, idx) => (
//                                         // tableData.map((row, idx) => (


//                                         <tr key={idx} className="border-b border-[#94BBE9] text-mytextlight dark:text-mytextdark ">



//                                             <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] ">
//                                                 {row.client}
//                                             </td>


//                                             <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] ">
//                                                 {row.status}
//                                             </td>

//                                             <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] text-mytextlight dark:text-mytextdark   ">

//                                                 {(row.status === "Pending" || editRowId === row.id) ? (
//                                                     <select
//                                                         className="w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm text-black"


//                                                         value={workingOnMap[row.id] || "By Alert Copier"} // default to "alert"
//                                                         onChange={(e) => handleWorkingOnChange(row.id, e.target.value)}
//                                                     >
//                                                         <option className="bg-white" value="alert">By Webhook</option>
//                                                         {/* <option className="bg-white" value="copier">By Trade Copier</option> */}
//                                                     </select>) : ` ${row.working_on} `
//                                                 }
//                                             </td>

//                                             <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] text-mytextlight dark:text-mytextdark ">

//                                                 {
//                                                     (row.status === "Pending" || editRowId === row.id) ? (
//                                                         <input
//                                                             type="number"
//                                                             value={multiplier[row.id] || row.quantity_multiplier}
//                                                             onChange={(e) => handleMultiplier(e, row.id)}
//                                                             onFocus={(e) => e.target.select()}

//                                                             className="w-full bg-white text-black border border-gray-300 rounded-md p-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
//                                                         />
//                                                     ) : (
//                                                         `${row.quantity_multiplier
//                                                         }`
//                                                     )
//                                                 }

//                                             </td>

//                                             <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] ">

//                                                 {row.reject_reason}

//                                             </td>

//                                             <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] ">

//                                                 <div className="flex items-center gap-2">
//                                                     {row.pause_copier ? (
//                                                         <>


//                                                             <FaPlay onClick={() => handlePauseCopier(row.id)} className=" w-3 h-3 hover:cursor-pointer" />
//                                                             <span className=" text-sm font-medium">Inactive</span>

//                                                         </>
//                                                     ) : (
//                                                         <>

//                                                             <FaPause onClick={() => handlePauseCopier(row.id)} className=" w-3 h-3 hover:cursor-pointer" />
//                                                             <span className=" text-sm font-medium  ">Active</span>


//                                                         </>
//                                                     )}
//                                                 </div>

//                                             </td>






//                                             <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] ">
//                                                 {row.status === "Pending" && (
//                                                     <div className="flex gap-2">

//                                                         <>

//                                                             <button
//                                                                 onClick={() => handleApproveUser(row.id)}
//                                                                 className="flex items-center justify-center gap-1 bg-green-600 text-white rounded text-xs
//                                                        w-32 h-8 sm:w-36 sm:h-9"
//                                                             >
//                                                                 <MdCheckCircle className="text-sm" />
//                                                                 Approve
//                                                             </button>

//                                                             <button
//                                                                 onClick={() => handleRemoveCopier(row.id)}
//                                                                 className="flex items-center justify-center gap-1 bg-red-500 text-white rounded text-xs
//                                                       w-32 h-8 sm:w-36 sm:h-9"
//                                                             >
//                                                                 <FaTrash className="text-sm" />
//                                                                 Remove Request
//                                                             </button>

//                                                         </>
//                                                     </div>


//                                                 )}

//                                                 {row.status === "Approved" && (
//                                                     <>
//                                                         {editRowId === row.id ? (
//                                                             <div className="flex gap-2">
//                                                                 <button
//                                                                     onClick={() => handleApproveUser(row.id)}
//                                                                     // className="bg-blue-500 text-white px-3 py-2 rounded-md"
//                                                                     className="flex items-center justify-center gap-1 bg-blue-500 text-white rounded text-xs
//                                                       w-32 h-8 sm:w-36 sm:h-9"
//                                                                 >
//                                                                     <FaRegSave />

//                                                                     Save
//                                                                 </button>
//                                                                 <button
//                                                                     onClick={handleCancel}
//                                                                     // className="bg-gray-400 text-white px-3 py-2 rounded-md"
//                                                                     className="flex items-center justify-center gap-1 bg-gray-400 text-white rounded text-xs
//                                                       w-32 h-8 sm:w-36 sm:h-9"

//                                                                 >
//                                                                     <MdOutlineCancel />
//                                                                     Cancel
//                                                                 </button>
//                                                             </div>
//                                                         ) : (
//                                                             <div className="flex gap-2">
//                                                                 <button
//                                                                     onClick={() => handleEdit(row.id)}
//                                                                     className="flex items-center justify-center gap-1 bg-yellow-500 text-white rounded text-xs
//                                                       w-32 h-8 sm:w-36 sm:h-9"
//                                                                 >
//                                                                     <FaEdit className="text-sm" />
//                                                                     Edit
//                                                                 </button>
//                                                                 <button
//                                                                     onClick={() => handleRemoveCopier(row.id)}
//                                                                     className="flex items-center justify-center gap-1 bg-red-500 text-white rounded text-xs
//                                                       w-32 h-8 sm:w-36 sm:h-9"
//                                                                 >

//                                                                     <FaTrash className=" text-sm"></FaTrash>
//                                                                     Remove Request


//                                                                 </button>
//                                                             </div>
//                                                         )}
//                                                     </>
//                                                 )}


//                                             </td>




//                                         </tr>

//                                     ))
//                                 )}




//                             </tbody>
//                         </table>

//                     </div>




//                 </div>

//                 <div className="  flex justify-center  gap-2 flex-wrap mt-2">
//                     {Array.from({ length: totalPages }, (_, index) => (
//                         <button
//                             key={index + 1}
//                             onClick={() => setCurrentPage(index + 1)}
//                             className={`px-3 py-1 text-sm sm:text-base rounded ${currentPage === index + 1
//                                 ? "bg-blue-600 text-white"
//                                 : "bg-gray-200 text-black"
//                                 }`}
//                         >
//                             Page {index + 1}
//                         </button>
//                     ))}
//                 </div>


//             </div>





//         </div>


//     );
// };

// export default ClientTableView;



// ClientTableView.jsx
import React, { useEffect, useState } from "react";
import { FaEdit, FaTrash } from 'react-icons/fa';
import { useAuth } from "../../context/auth";
import { copierPauseService } from "../apiservice/copierPuaseService";
import { FaPause, FaPlay, FaRegSave } from "react-icons/fa";
import { toast } from "react-toastify";
import { acceptCopierService } from "../apiservice/acceptCopierService";
import { MdCheckCircle, MdOutlineCancel } from 'react-icons/md';
import { FiRefreshCcw } from "react-icons/fi";

const ClientTableView = ({ clientDetails, handleRemoveCopier, setClientData, fetchCopierData }) => {

    const [editRowId, setEditRowId] = useState(null);
    const [editedRowData, setEditedRowData] = useState({});
    const { getLoginToken, getLoginMail, getGoogleAuthToken } = useAuth();
    const [loading, setLoading] = useState(false);

    const [multiplier, setMultiplier] = useState({});
    const [workingOnMap, setWorkingOnMap] = useState({});

    const token = getLoginToken() || getGoogleAuthToken();

    const handleWorkingOnChange = (id, value) => {
        setWorkingOnMap((prev) => ({
            ...prev,
            [id]: value,
        }));
    };

    const handleMultiplier = (e, id) => {
        const value = Number(e.target.value);
        setMultiplier((prev) => ({
            ...prev,
            [id]: value,
        }));
    };

    const selectedIds = clientDetails.map(item => item.id)
    const Allstatus = clientDetails.map(item => item.status)
    const allpause = clientDetails.map(item => item.pause_copier)

    const handleAllPause = async (id) => {
        try {
            setLoading(true);

            for (const id of selectedIds) {
                const data = {
                    id: id,
                    pause: false
                }
                if (allpause.some(Boolean)) {
                    const response = await copierPauseService(token, data);

                    if (response.status === 200 && !response.data?.error) {
                        setClientData((prevRows) =>
                            prevRows.map((row) =>
                                row.id === id ? { ...row, pause_copier: false } : row
                            )
                        );
                        await new Promise(resolve => setTimeout(resolve, 3000));
                        toast.success(response?.data?.data)
                    } else {
                        toast.error(response?.data?.data)
                    }
                }
            }
        } catch (error) {
            toast.error(error?.response?.data.data?.message || error.message)
        } finally {
            setLoading(false);
        }
    };

    const handleAllUnPause = async (id) => {
        try {
            setLoading(true);

            for (const id of selectedIds) {
                const data = {
                    id: id,
                    pause: true
                }
                if (allpause.some(pause => !pause)) {
                    const response = await copierPauseService(token, data);

                    if (response.status === 200 && !response.data?.error) {
                        setClientData((prevRows) =>
                            prevRows.map((row) => row.id === id ? { ...row, pause_copier: true } : row)
                        )
                        await new Promise(resolve => setTimeout(resolve, 3000));
                        toast.success(response?.data?.data)
                    } else {
                        toast.error(response?.data?.data)
                    }
                }
            }
        } catch (error) {
            toast.error(error?.response?.data.data?.message || error.message)
        } finally {
            setLoading(false);
        }
    };

    const handlePauseCopier = async (id) => {
        const data = {
            id: id
        }

        try {
            setLoading(true);

            const response = await copierPauseService(token, data);

            if (response.status === 200 && !response.data?.error) {
                setClientData((prevRows) =>
                    prevRows.map((row) =>
                        row.id === id ? { ...row, pause_copier: !row.pause_copier } : row
                    )
                );
                await new Promise(resolve => setTimeout(resolve, 3000));
                toast.success(response?.data?.data)
            } else {
                toast.error(response?.data?.data)
            }
        } catch (error) {
            console.error("API Error:", error?.response?.data?.error || error.message);
            toast.error(error?.response?.data?.error || error.message);
        } finally {
            setLoading(false);
        }
    };

    // Called when user clicks "Edit"
    const handleEdit = (id) => {
        const row = clientDetails.find((row) => row.id === id);
        setEditRowId(id);
        setEditedRowData({ ...row });
    };

    // Called when user clicks "Cancel"
    const handleCancel = () => {
        setEditRowId(null);
        setEditedRowData({});
    };

    const handleApproveUser = async (id) => {
        const selectedWorkingOn = workingOnMap[id] || "By Alert Copier";
        const in_alert_use = selectedWorkingOn === "By Alert Copier";
        const multiplierData = multiplier[id] || 1;

        const acceptData = {
            id: id,
            in_alert_use,
            quantity_multiplier: Number(multiplierData)
        };

        try {
            const response = await acceptCopierService(token, acceptData);

            if (response.status === 200) {
                if (response?.data?.error === false) {
                    setClientData((prevRows) =>
                        prevRows.map((row) =>
                            row.id === id ? { ...row, pause_copier: !row.pause_copier } : row
                        )
                    );
                    setEditRowId(null);
                    toast.success(response?.data?.data)
                } else {
                    toast.error(response?.data?.data)
                }
            }
        } catch (error) {
            console.error("Approval error:", error);
            toast.error(error?.response?.data?.error || error.message);
        }
    };

    const currentMail = getLoginMail();
    const clientMail = clientDetails.filter((client) => client.client !== currentMail);

    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 15;

    // Calculate total pages
    const totalPages = Math.ceil(clientDetails.length / rowsPerPage);

    // Get current page data
    const startIdx = (currentPage - 1) * rowsPerPage;
    const clientCurrentRows = clientMail.slice(startIdx, startIdx + rowsPerPage);

    return (
        <div className='m-screen h-screen'>
            <div className="overflow-x-auto p-4">
                {/* Main Container - Dark Mode Added */}
                <div className="backdrop-blur-md bg-white/70 dark:bg-[#1d1d1f]/90 rounded-xl shadow-lg pl-4 pr-4 pb-4 min-w-[900px] min-h-[500px]">
                    
                    {/* Button Section - Dark Mode Added */}
                    <div className="w-full">
                        <div className="w-full flex flex-row justify-between my-4">
                            <div className="flex flex-wrap gap-2">
                                <div className="flex items-center">
                                    <button
                                        onClick={handleAllPause}
                                        disabled={loading}
                                        className="shadow-2xl px-4 py-2 border font-medium border-gray-900 dark:border-gray-600 bg-green-500 rounded-md text-white hover:bg-green-600 active:bg-green-700 transition-colors duration-200"
                                    >
                                        Active All
                                    </button>
                                </div>
                                <div className="flex items-center justify-center">
                                    <button 
                                        onClick={handleAllUnPause}
                                        disabled={loading}
                                        className="shadow-2xl px-4 py-2 border font-medium border-gray-900 dark:border-gray-600 bg-red-500 rounded-md text-white hover:bg-red-600 active:bg-red-700 transition-colors duration-200"
                                    >
                                        Inactive All
                                    </button>
                                </div>
                            </div>

                            {/* Refresh Button - Dark Mode Added */}
                            <button
                                onClick={fetchCopierData}
                                className="relative py-2 px-2 rounded-md border border-gray-400 dark:border-gray-600 text-gray-800 dark:text-gray-300 font-medium flex items-center justify-center hover:text-blue-500 dark:hover:text-blue-400 transition-transform duration-500 hover:rotate-180"
                            >
                                <FiRefreshCcw className="h-5 w-5 text-center" />
                            </button>
                        </div>

                        {/* Table - Dark Mode Added */}
                        <table className="min-w-full table-auto text-xs text-left border border-[#94BBE9] dark:border-gray-700 mt-3">
                            <thead className="bg-blue-50 dark:bg-gray-800 text-blue-800 dark:text-gray-200">
                                <tr>
                                    <th className="min-w-[10px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                                        <div className="flex items-center justify-between gap-1">
                                            Client Mail
                                        </div>
                                    </th>
                                    <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                                        <div className="flex items-center justify-between gap-1">
                                            Request Status
                                        </div>
                                    </th>
                                    <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                                        <div className="flex items-center justify-between gap-1">
                                            Copier In Use
                                        </div>
                                    </th>
                                    <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                                        <div className="flex items-center justify-between gap-1">
                                            Multiplier
                                        </div>
                                    </th>
                                    <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                                        <div className="flex items-center justify-between gap-1">
                                            Message
                                        </div>
                                    </th>
                                    <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                                        <div className="flex items-center justify-between gap-1">
                                            Status
                                        </div>
                                    </th>
                                    <th className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700 whitespace-nowrap font-semibold relative">
                                        <div className="flex items-center justify-between gap-1">
                                            Action
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {clientDetails.length === 0 ? (
                                    <tr>
                                        <td
                                            colSpan={7}
                                            className="min-w-[30px] text-center py-4 border border-[#94BBE9] dark:border-gray-700 text-gray-500 dark:text-gray-400"
                                        >
                                            No alerts found
                                        </td>
                                    </tr>
                                ) : (
                                    Array.isArray(clientCurrentRows) && clientCurrentRows.map((row, idx) => (
                                        <tr key={idx} className="border-b border-[#94BBE9] dark:border-gray-700 text-mytextlight dark:text-gray-300">
                                            <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                                                {row.client}
                                            </td>
                                            <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                                                {row.status}
                                            </td>
                                            <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                                                {(row.status === "Pending" || editRowId === row.id) ? (
                                                    <select
                                                        className="w-full border border-gray-300 dark:border-gray-600 rounded-md shadow-sm p-2 text-sm text-black dark:text-white dark:bg-gray-700"
                                                        value={workingOnMap[row.id] || "By Alert Copier"}
                                                        onChange={(e) => handleWorkingOnChange(row.id, e.target.value)}
                                                    >
                                                        <option className="bg-white dark:bg-gray-700" value="alert">By Webhook</option>
                                                    </select>
                                                ) : `${row.working_on}`}
                                             </td>
                                            <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                                                {(row.status === "Pending" || editRowId === row.id) ? (
                                                    <input
                                                        type="number"
                                                        value={multiplier[row.id] || row.quantity_multiplier}
                                                        onChange={(e) => handleMultiplier(e, row.id)}
                                                        onFocus={(e) => e.target.select()}
                                                        className="w-full bg-white dark:bg-gray-700 text-black dark:text-white border border-gray-300 dark:border-gray-600 rounded-md p-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                                                    />
                                                ) : (
                                                    `${row.quantity_multiplier}`
                                                )}
                                             </td>
                                            <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                                                {row.reject_reason}
                                             </td>
                                            <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                                                <div className="flex items-center gap-2">
                                                    {row.pause_copier ? (
                                                        <>
                                                            <FaPlay 
                                                                onClick={() => handlePauseCopier(row.id)} 
                                                                className="w-3 h-3 hover:cursor-pointer text-green-500 dark:text-green-400 hover:text-green-600 dark:hover:text-green-300"
                                                            />
                                                            <span className="text-sm font-medium text-red-600 dark:text-red-400">Inactive</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <FaPause 
                                                                onClick={() => handlePauseCopier(row.id)} 
                                                                className="w-3 h-3 hover:cursor-pointer text-yellow-500 dark:text-yellow-400 hover:text-yellow-600 dark:hover:text-yellow-300"
                                                            />
                                                            <span className="text-sm font-medium text-green-600 dark:text-green-400">Active</span>
                                                        </>
                                                    )}
                                                </div>
                                             </td>
                                            <td className="min-w-[30px] px-2 py-2 border border-[#94BBE9] dark:border-gray-700">
                                                {row.status === "Pending" && (
                                                    <div className="flex gap-2">
                                                        <button
                                                            onClick={() => handleApproveUser(row.id)}
                                                            className="flex items-center justify-center gap-1 bg-green-600 hover:bg-green-700 text-white rounded text-xs w-32 h-8 sm:w-36 sm:h-9 transition-colors duration-200"
                                                        >
                                                            <MdCheckCircle className="text-sm" />
                                                            Approve
                                                        </button>
                                                        <button
                                                            onClick={() => handleRemoveCopier(row.id)}
                                                            className="flex items-center justify-center gap-1 bg-red-500 hover:bg-red-600 text-white rounded text-xs w-32 h-8 sm:w-36 sm:h-9 transition-colors duration-200"
                                                        >
                                                            <FaTrash className="text-sm" />
                                                            Remove Request
                                                        </button>
                                                    </div>
                                                )}

                                                {row.status === "Approved" && (
                                                    <>
                                                        {editRowId === row.id ? (
                                                            <div className="flex gap-2">
                                                                <button
                                                                    onClick={() => handleApproveUser(row.id)}
                                                                    className="flex items-center justify-center gap-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-xs w-32 h-8 sm:w-36 sm:h-9 transition-colors duration-200"
                                                                >
                                                                    <FaRegSave />
                                                                    Save
                                                                </button>
                                                                <button
                                                                    onClick={handleCancel}
                                                                    className="flex items-center justify-center gap-1 bg-gray-400 hover:bg-gray-500 text-white rounded text-xs w-32 h-8 sm:w-36 sm:h-9 transition-colors duration-200"
                                                                >
                                                                    <MdOutlineCancel />
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div className="flex gap-2">
                                                                <button
                                                                    onClick={() => handleEdit(row.id)}
                                                                    className="flex items-center justify-center gap-1 bg-yellow-500 hover:bg-yellow-600 text-white rounded text-xs w-32 h-8 sm:w-36 sm:h-9 transition-colors duration-200"
                                                                >
                                                                    <FaEdit className="text-sm" />
                                                                    Edit
                                                                </button>
                                                                <button
                                                                    onClick={() => handleRemoveCopier(row.id)}
                                                                    className="flex items-center justify-center gap-1 bg-red-500 hover:bg-red-600 text-white rounded text-xs w-32 h-8 sm:w-36 sm:h-9 transition-colors duration-200"
                                                                >
                                                                    <FaTrash className="text-sm" />
                                                                    Remove Request
                                                                </button>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                             </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Pagination Buttons - Dark Mode Added */}
                <div className="flex justify-center gap-2 flex-wrap mt-2">
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index + 1}
                            onClick={() => setCurrentPage(index + 1)}
                            className={`px-3 py-1 text-sm sm:text-base rounded transition-colors duration-200 ${
                                currentPage === index + 1
                                    ? "bg-blue-600 text-white dark:bg-blue-500"
                                    : "bg-gray-200 text-black dark:bg-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600"
                            }`}
                        >
                            Page {index + 1}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ClientTableView;